import { TableCell, TableHead, TableRow, TableSortLabel } from 'material-ui/Table';
import Tooltip from 'material-ui/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';

class ReservationsTableHeader extends React.Component {

    constructor(props) {
        super(props);
        const B2bVerPVP = props.user.authorities.includes('B2bVerPVP');
        const priceColumn = B2bVerPVP ?
            {
                id: 'pvp',
                width: '10px',
                sortType: 'Number',
                numeric: false,
                disablePadding: false,
                label: this.props.onlyShowPvpPrice ? props.t('COMMON.AMOUNT') : props.t('BOOKINGS.PVP')
            }
            :
            {
                id: 'price',
                width: '10px',
                sortType: 'Number',
                numeric: false,
                disablePadding: false,
                label: props.t('BOOKINGS.PRICE')
            };

        let cols = [
            {
                id: 'pendingPaymentCheck',
                width: '10px',
                sortType: 'String',
                numeric: false,
                disablePadding: true,
                label: '',
            },
            {
                id: 'type',
                width: '40px',
                sortType: 'String',
                paddingLeft: '2px',
                numeric: false,
                disablePadding: false,
                label: props.t('BOOKINGS.TYPE'),
            },
            {
                id: 'olympiaLocator',
                width: '100px',
                sortType: 'String',
                paddingLeft: '2px',
                numeric: false,
                disablePadding: false,
                label: props.t('BOOKINGS.LOCATOR'),
            },
            { id: 'agencyCode', sortType: 'String', width: '10px', numeric: false, disablePadding: false, label: props.t('BOOKINGS.AGENCY') },
            { id: 'creationDate', width: '100px', sortType: 'Date', numeric: false, disablePadding: false, label: props.t('BOOKINGS.BOOKING_DATE') },
            {
                id: 'clientLocator',
                width: '100px',
                numeric: false,
                disablePadding: false,
                label: props.t('BOOKINGS.AGENCY_LOCATOR')
            },
            { id: 'checkIn', width: '100px', sortType: 'Date', numeric: false, disablePadding: true, label: props.t('COMMON.CHECK_IN') },
            { id: 'checkOut', width: '100px', sortType: 'Date', numeric: false, disablePadding: true, label: props.t('COMMON.CHECK_OUT') },
            { id: 'hotel.name', width: '100px', sortType: 'String', numeric: false, disablePadding: true, label: props.t('COMMON.HOTEL') },
            { id: 'holder.name', width: '100px', sortType: 'String', numeric: false, disablePadding: true, label: props.t('BOOKINGS.CLIENT') },
            //{ id: 'employeeCode1', width: '10px', numeric: false, disablePadding: false, label: 'Expediente' },
            priceColumn,
            {
                id: 'pendingPayment.price',
                width: '10px',
                sortType: 'Number',
                numeric: false,
                disablePadding: false,
                label: props.t('COMMON.PENDING_AMOUNT_TO_PAY')
            },
            { id: 'actions', width: '32px', sortType: 'NoSort', numeric: false, disablePadding: false, label: props.t('BOOKINGS.ACTIONS') },
            { id: 'state', width: '32px', numeric: false, disablePadding: false, label: props.t('BOOKINGS.STATE') },
        ];
        //B2B-178 solo si es la web olympia.
        if (this.props.clientName === 'B2BWebOlympia') {
            cols.splice(3, 0, {
                id: 'market.label',
                width: '10px',
                sortType: 'String',
                paddingLeft: '2px',
                numeric: false,
                disablePadding: false,
                label: props.t('COMMON.MARKET'),
            });
        }

        this.state = { columnData: cols };
    }

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property, this.state.columnData);
    };

    mustAddAgencyNameColumn() {
        let user = JSON.parse(localStorage.getItem('user'));

        return user.authorities.includes('B2BReservasPorFacturacion');
    }

    hideAgencyNameColumn() {
        // elimina la columna agencyName
        if (!this.mustAddAgencyNameColumn()) {
            let columnData = this.state.columnData.filter(column => column.id !== 'agencyCode');
            this.setState({ columnData });
        }
    }

    componentDidMount() {
        this.hideAgencyNameColumn();
    }

    render() {
        const { order, orderBy, t } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {this.state.columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                width={column.width}
                                style={{
                                    width: column.width,
                                    backgroundColor: '#e5e5e5',
                                    color: '#555555',
                                    fontWeight: 700,
                                    paddingLeft: '14px',
                                    borderRight: '2px solid #f5f5f5',
                                }}
                                padding={'none'}
                                sortDirection={orderBy === column.id ? order : false}>
                                {
                                    column.sortType !== 'NoSort' ?
                                        <Tooltip
                                            title={column.sortType !== 'NoSort' ? t('BOOKINGS.SORT') : ''}
                                            placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                            enterDelay={300}>
                                            <TableSortLabel
                                                active={orderBy === column.id}
                                                direction={order}
                                                onClick={column.sortType !== 'NoSort' ? this.createSortHandler(column.id) : null}>
                                                {column.label}
                                            </TableSortLabel>
                                        </Tooltip>
                                        :
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={order}
                                            onClick={column.sortType !== 'NoSort' ? this.createSortHandler(column.id) : null}>
                                            {column.label}
                                        </TableSortLabel>
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

ReservationsTableHeader.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    clientName: PropTypes.string.isRequired,
};

export default translate('translations')(ReservationsTableHeader);



// WEBPACK FOOTER //
// ./src/components/Reservations/Table/ReservationsTableHeader.js